import { Button } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

export function AddTaskButton({ onClick }) {
    return (
        <Button data-cy="add-task-button" startIcon={<Iconify icon={"ic:baseline-plus"} />} onClick={onClick}>
            Add Task
        </Button>
    )
}
